export const adyenEnvironment = (env: string) =>
  env === 'test' ? 'test' : 'live';
